<template>
    <span class="inline-flex rounded-md shadow-sm ">
        <button :disabled="disabled" :type="type" class="ui-btn" :class="[`ui-btn-${size}`, `ui-btn-${color}`, rounded, btnCls]">
            <slot>button</slot>
        </button>
    </span>
</template>

<script>
export default {
  name: "UiButton",
  props: {
    color: {
      default: 'primary'
    },
    type: {
      default: 'button'
    },
    size: {
      default: 'md'
    },
    disabled: {
      default: false
    },
    btnCls: {
      default: ''
    },
    rounded: {
      default: 'rounded-md'
    }
  },
}
</script>

<style lang="scss">

.ui-btn {
  &:disabled {
    cursor: not-allowed;
    opacity: .6;
  }
}

.ui-btn-white {
  @apply border-gray-300 text-primary-700 bg-white;
  &:hover {
    @apply text-primary-500;
  }

  &:focus {
    @apply border-primary-300 ring ring-primary-200;
  }

  &:active {
    @apply bg-gray-50 text-primary-800 ;
  }

}

.ui-btn-red {
  @apply border-transparent text-white bg-red-600;
  &:hover {
    @apply bg-red-500;
  }

  &:focus {
    @apply border-red-700 ring ring-red-200;
  }
}

.ui-btn-primary {
  @apply border-transparent text-white bg-primary-600;
  &:hover {
    @apply bg-primary-500;
  }

  &:focus {
    @apply border-primary-700 ring-2 ring-offset-2 ring-offset-gray-50 ring-primary-500 ;
  }
}

.ui-btn-blue {
  @apply border-transparent text-white bg-blue-600;
  &:hover {
    @apply bg-blue-500;
  }

  &:focus {
    @apply border-blue-700  ring-2 ring-offset-2 ring-offset-gray-50 ring-blue-500 ;
  }
}

.ui-btn-light-blue {
  @apply border-transparent text-white bg-sky-600;
  &:hover {
    @apply bg-sky-500;
  }

  &:focus {
    @apply border-blue-700  ring ring-blue-200;
  }
}

.ui-btn-green {
  @apply border-transparent text-white bg-green-600;
  &:hover {
    @apply bg-green-500;
  }

  &:focus {
    @apply border-green-700 ring-2 ring-offset-2 ring-offset-gray-50 ring-green-500 ;
  }
}

.ui-btn-indigo {
  @apply border-transparent text-white bg-indigo-600 ;
  &:hover {
    @apply bg-indigo-500;
  }

  &:focus {
    @apply border-indigo-700 ring-2 ring-offset-2 ring-offset-gray-50 ring-indigo-500 ;
  }
}


.ui-btn-orange {
  @apply border-transparent text-white bg-orange-600 ;
  &:hover {
    @apply bg-orange-500;
  }

  &:focus {
    @apply border-orange-700 ring-2 ring-offset-2 ring-offset-gray-50 ring-orange-500;
  }
}

/* ring-2 ring-offset-2 ring-offset-gray-50 ring-orange-500 */

.ui-btn {
  @apply inline-flex w-full justify-center border font-medium;
  &:focus {
    @apply outline-none ;
  }
}

.ui-btn-xs {
  @apply px-2.5 py-1.5 text-xs leading-4;
}

.ui-btn-sm {
  @apply px-3 py-2 text-sm leading-4;
}

.ui-btn-md {
  @apply px-4 py-2 text-sm leading-5;
}

.ui-btn-lg {
  @apply px-4 py-3 text-base leading-6;
}

.ui-btn-xl {
  @apply px-6 py-3 text-base leading-6;
}


</style>